import React, { useState } from 'react';
import HelpCard from '../HelpCard';

const BalanceSheetHelp = (props) => {
    const fields = [
        { id: "1", name: "Period", shortcutKey: "F2", state: props.setShow },
        { id: "4", name: "Valuaion", shortcutKey: "F8", state: props.setShowMonthly },
        { id: "9", name: "Basis of Value", shortcutKey: "B", state: props.setShowBasis },
        { id: "10", name: "Change View", shortcutKey: "H", state: props.setShowChange },
        { id: "11", name: "Exception Reposts", shortcutKey: "J", state: props.setShowReport },
    ];

    return (
        <>
            {
                fields.map((item, index) => {
                    return (
                        <HelpCard key={item.id} fields={item} />
                    )
                })
            }
            <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                <div className='help_button_card mb-1 ms-1' >
                    <button className={`button_padding`}>
                        <p className='card-header'>
                            <span>F12</span>:
                            Configure
                        </p>
                    </button>
                </div>
            </div>

        </>
    )
}

export default BalanceSheetHelp;
